export default function DataTable({ columns, rows, empty = "No records yet.", testid, rowKey = (r, i) => r.id || i }) {
  const list = Array.isArray(rows) ? rows : [];
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="min-w-full text-left text-sm">
        <thead className="border-b border-border bg-surface-2/60 text-xs uppercase tracking-wide text-muted-foreground">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className={`whitespace-nowrap px-4 py-3 font-medium ${c.align === "right" ? "text-right" : ""}`}
                style={{ width: c.width }}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {list.length === 0 ? (
            <tr><td colSpan={columns.length} className="px-4 py-16 text-center text-sm text-muted-foreground">{empty}</td></tr>
          ) : list.map((r, i) => (
            <tr key={rowKey(r, i)} className="border-b border-border/70 last:border-0 hover:bg-surface-2/40" data-testid={r._testid}>
              {columns.map((c) => (
                <td key={c.key} className={`px-4 py-3 align-middle ${c.align === "right" ? "num text-right" : ""} ${c.cls || ""}`}>
                  {c.render ? c.render(r) : r[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
